
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'

export default defineComponent({
  name: 'ProfileMenuItem',
  components: { AButton },
  emits: ['click'],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onclick(event: any) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    },
  },
})
